import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import Layouts from "../layouts/index";

const DeviceListPage = lazy(() => import("../pages/devices/DevicesList"));
const ProductAdd = lazy(() => import("../pages/devices/AddDevice"));
const DeviceView = lazy(() => import("../pages/devices/ViewDevice"));

const routesForm = [
  {
    path: "/*",
    element: <Navigate to="/devices" />,
  },
  {
    path: "/home",
    element: <Layouts />,
    /* children: [
      {
        path: "/home",
        element: <Home />,
      },
    ], */
  },
  {
    path: "/devices",
    element: <Layouts />,
    children: [
      {
        path: "/devices",
        element: <DeviceListPage />,
      },
      {
        path: "/devices/add-device",
        element: <ProductAdd />,
      },
      {
        path: "/devices/edit-device",
        element: <ProductAdd />,
      },
      {
        path: "/devices/view-device",
        element: <DeviceView />,
      },
    ],
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };
